import { useMutation, useQueryClient } from '@tanstack/react-query';
import TenantService from '@clickersphere/core/services/TenantService';
import { LOGGED_IN_USER_QUERY_KEY, UserMeQueryData } from '../user/useUserMe';

export function useTenantSignIn() {
  const queryClient = useQueryClient();
  const { mutateAsync: tenantSignInAsync, isPending: tenantSignInIsPending } =
    useMutation({
      mutationFn: async (id: string) => TenantService.signin(id),
      onSuccess: async (_data, tenantId) => {
        await queryClient.cancelQueries({ queryKey: LOGGED_IN_USER_QUERY_KEY });

        // Remove queries from previous tenant to free memory
        queryClient.removeQueries({
          predicate: (query) => {
            const key = query.queryKey;
            // Keep user 'me' query, remove tenant-scoped queries
            return (
              Array.isArray(key) &&
              key.length > 0 &&
              key[0] !== tenantId &&
              key !== LOGGED_IN_USER_QUERY_KEY &&
              key[0] !== 'users'
            );
          },
        });

        queryClient.setQueryData<UserMeQueryData>(
          LOGGED_IN_USER_QUERY_KEY,
          (old) => {
            if (!old) return old;

            return {
              ...old,
              selectedTenantId: tenantId,
              queryStatus: undefined,
            };
          },
        );
      },
    });

  return {
    tenantSignInAsync,
    tenantSignInIsPending,
  };
}
